import  * as actions from '../actions/actionTypes'
import { IFocusMatchState } from '../types/IFocusMatch';
import { AnyAction } from 'redux';

const initialState: IFocusMatchState = {
  status: null
}

const focusMatch = ( state: IFocusMatchState = initialState, action: AnyAction ) : IFocusMatchState => {
  switch (action.type) {
    case actions.FOCUSMATCHSTATUS_VALIDATED:
      return Object.assign({}, state, {status: action.status});
    default:
      return state
  }
}

export const getFocusMatchStatus = (state:any) => {
  return state.focusMatch.status
}
export const getLayout = (state:any) => {
  return state.config.layout
}

export default focusMatch
